import { render, staticRenderFns } from "./Aboutpage.vue?vue&type=template&id=18bf4ee0&scoped=true&"
import script from "./Aboutpage.vue?vue&type=script&lang=js&"
export * from "./Aboutpage.vue?vue&type=script&lang=js&"
import style0 from "./Aboutpage.vue?vue&type=style&index=0&id=18bf4ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf4ee0",
  null
  
)

export default component.exports